import {Actions, createEffect, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {catchError, EMPTY, switchMap, tap} from 'rxjs';
import {Injectable} from '@angular/core';
import {AddressTypeService} from "@modules/address/services/address-type.service";
import {AddressTypeApi} from "@modules/address/api/address-type.api";

@Injectable()
export class AddressTypeInitializerEffects {
  initAddressTypes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.addressTypeApi.get$()),
      tap(addressTypes => this.addressTypeService.dispatchSetEntities(addressTypes)),
      catchError(e => {
        console.error(e);

        this.addressTypeService.dispatchClearEntitiesAction()

        return EMPTY;
      }),
    )
  }, {dispatch: false});

  constructor(
    private actions$: Actions,
    private addressTypeApi: AddressTypeApi,
    protected readonly addressTypeService: AddressTypeService
  ) {
  }
}
